import { render, staticRenderFns } from "./MeterTypeForm.vue?vue&type=template&id=38950bd8"
import script from "./MeterTypeForm.vue?vue&type=script&lang=js"
export * from "./MeterTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports